/* eslint-disable no-underscore-dangle */
import type { MeetingsQuickSwitcherData, QuickSwitcherData } from '@ps/isp-web-services-types';

export const isMeetingBasedQuickSwitcherData = (
  data?: QuickSwitcherData
): data is MeetingsQuickSwitcherData => data?._type === 'MEETINGS';
